module.exports = function getResource(label, vars = []) {
    let resources = {
        item: 'ITEM',
        items: 'items',
        qty: 'QTY',
        basketTotal: 'Basket total',
        subTotal: 'Subtotal',
        checkout: 'Checkout',
        continue: 'Continue Shopping',
        seeSamples: 'See samples, rewards and promotions in',
        basket: 'basket',
        title: 'Added to Basket',
        reserveTitle: `Added to Basket for Pickup at ${vars[0]}`,
        proceedToBasket: 'Proceed to Basket',
        viewInBasket: 'View in Basket',
        viewAndCheckout: 'View Basket & Checkout',
        viewAndReserve: 'View Basket & Reserve',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.',
        testCreditCardMessageTitle: 'Don’t Forget to Use Your Sephora Credit Card',
        testSeeDetails: 'See details',
        testCardDiscount: `Save ${vars[0]} off your Sephora order when you open and use your Sephora Credit Card.`,
        testCardDiscountTitle: 'Open a Sephora Credit Card Today'
    };

    return resources[label];
};
